<template>
    <div class="tasks-main">
        <div class="admin-header">
            <div class="admin-header-left">
                <div class="text-header">
                    <span>Import from Job Board</span>
                </div>
            </div>
            <div class="admin-header-right">
                <vbutton
                    :label="'admin.company.board.search.table.create'"
                    @click="toggle_modal(true)"
                />
            </div>
        </div>
        <vtable class="admin-table vacancies-table" v-if="tasks && tasks.length">
            <thead>
                <th class="admin-table-board-id">ID</th>
                <th class="admin-table-board-board">{{$tr('admin.company.board.search.table.board')}}</th>
                <th class="admin-table-board-vacancy">{{$tr('admin.company.board.search.table.vacancy')}}</th>
                <th class="admin-table-board-cycle">{{$tr('admin.company.board.search.table.cycle')}}</th>
                <th class="admin-table-board-number">{{$tr('admin.company.board.search.table.number')}}</th>
                <th class="admin-table-board-period">{{$tr('admin.company.board.search.table.period')}}</th>
                <th class="admin-table-board-last_search">{{$tr('admin.company.board.search.table.last_search')}}</th>
                <th class="admin-table-board-next_search">{{$tr('admin.company.board.search.table.next_search')}}</th>
                <th class="admin-table-board-config"></th>
            </thead>
            <tbody>
                <task_row v-for="task in tasks" :key="task.id"
                    :task="task"
                    :citizenship_types="citizenship_types"
                    :education_levels="education_levels"
                    :employment_types="employment_types"
                    :relocation_preferences="relocation_preferences"
                    :job_functions="job_functions"
                    :companyId="companyId"
                    @update="update"
                />
            </tbody>
        </vtable>
        <div class="seekers-pagination-wrapper" v-if="tasks && tasks.length && page_count > 1">
            <vuetify-pagination v-if="tasks && tasks.length && page_count > 1"
                :page="page"
                :length="page_count"
                :total-visible="6"
                @input="input_page"
            ></vuetify-pagination>
        </div>
        <div class="table-last-row" v-if="!tasks || !tasks.length">
            <span class="table-last-row__note">{{tasks && tasks.length ? $tr('admin.company.board.search.new') : $tr('admin.company.board.search.empty')}}</span>
        </div>

        <board_modal
            v-if="is_dialog_visible"
            :is_visible="is_dialog_visible"
            :citizenship_types="citizenship_types"
            :education_levels="education_levels"
            :employment_types="employment_types"
            :relocation_preferences="relocation_preferences"
            :job_functions="job_functions"
            :companyId="companyId"
            @toggle_nexxt_dialog="toggle_modal"
            @submit="update"
            @close="toggle_modal(false)"
        />
    </div>
</template>

<script>
import axios from 'axios'
import task_row from './row';
import board_modal from './components/board_modal';

export default {
    name: 'admin-import-tasks',

    components: {
        task_row,
        board_modal
    },
    props: ['companyId'],

    data() {
        return {
            tasks: [],
            citizenship_types: [],
            education_levels: [],
            employment_types: [],
            relocation_preferences: [],
            job_functions: [],
            is_dialog_visible: false,
            page_count: 1,
            page: 1
        }
    },

    methods: {
        toggle_modal(val) {
            this.is_dialog_visible = val;
        },

        input_page(page) {
            this.page = page;
            this.fetch_tasks()
        },

        fetch_tasks() {
            axios.get(`/v2/boards/tasks`, {
                params: {
                    page: this.page,
                    'filter[company_id]': this.companyId
                }
            }).then(response => {
                const data = response.data;
                if (data && data._embedded && data._embedded.tasks) {
                    this.tasks = data._embedded.tasks
                }
                this.page_count = data._page_count
                this.page = data._page
                this.toggle_modal(false);
            })
        },

        update() {
            this.fetch_tasks();
        }
    },

    created() {
        this.fetch_tasks();

        axios.get(`/v2/boards/filters/citizenship_types`).then(response => {
            const data = response.data;
            if (data && data._embedded && data._embedded.citizenship_types) {
            this.citizenship_types = data._embedded.citizenship_types.map(item => {
                return Object.assign({}, item, {
                    id: item.nexxt_id
                })
            })
            }
        })

        axios.get(`/v2/boards/filters/education_levels`).then(response => {
            const data = response.data;
            if (data && data._embedded && data._embedded.education_levels) {
            this.education_levels = data._embedded.education_levels.map(item => {
                return Object.assign({}, item, {
                    id: item.nexxt_id
                })
            });
            }
        })

        axios.get(`/v2/boards/filters/employment_types`).then(response => {
            const data = response.data;
            if (data && data._embedded && data._embedded.employment_types) {
            this.employment_types = data._embedded.employment_types.map(item => {
                return Object.assign({}, item, {
                    id: item.nexxt_id
                })
            })
            }
        })

        axios.get(`/v2/boards/filters/relocation_preferences`).then(response => {
            const data = response.data;
            if (data && data._embedded && data._embedded.relocation_preferences) {
            this.relocation_preferences = data._embedded.relocation_preferences.map(item => {
                return Object.assign({}, item, {
                    id: item.nexxt_id
                })
            })
            }
        })

        axios.get(`/v2/boards/filters/job_functions`).then(response => {
            const data = response.data;
            if (data && data._embedded && data._embedded.job_functions) {
            this.job_functions = data._embedded.job_functions.map(item => {
                return Object.assign({}, item, {
                    id: item.nexxt_id
                })
            })
            }
        })
    }
}
</script>

<style lang="scss">
.tasks-main {
    .table-last-row {
        padding: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-top: 1px solid #D2D6E0;
        border-bottom: 1px solid #D2D6E0;
        margin-bottom: 40px;
    }
    .table-last-row__note {
        // font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 15px;
        line-height: 22px;
        letter-spacing: 0.005em;
        color: #9FAAB6;
    }

    .admin-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 8px;
    }

    .admin-header-left {
        display: flex;
    }

    .admin-header-right {
        display: flex;
    }

    .text-header {
        padding: 5px 0 20px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        // font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 28px;
        line-height: 41px;
        letter-spacing: 0.005em;
        color: #233346;
    }

    .admin-table th {
        // font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 15px;
        line-height: 22px;
        letter-spacing: 0.005em;
        color: #607183;
        border-bottom: 1px solid #D2D6E0;
        box-sizing: border-box;
        white-space: normal;
        padding: 17px 10px 17px 20px;
    }

    .admin-table td {
        // font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 15px;
        line-height: 22px;
        letter-spacing: 0.005em;
        color: #233346;
        height: 80px;
        vertical-align: middle;
        box-sizing: border-box;
        padding: 16px 10px 20px 20px;
    }

    .admin-table {
        tbody {
            tr {
                border-bottom: 1px solid #D2D6E0;
            }
        }

        .admin-table-board-cycle {
            width: 210px;
        }

        .admin-table-board-number {
            width: 132px;
        }

        .admin-table-board-period {
            width: 238px;
        }
    }

    .tasks-main {
        padding-bottom: 50px;

        .seekers-pagination-wrapper {
            display: flex;
            align-items: center;
            margin-top: 50px;
        }
    }
}
</style>
